import { render, staticRenderFns } from "./back_to_top.vue?vue&type=template&id=554e582b&"
import script from "./back_to_top.vue?vue&type=script&lang=js&"
export * from "./back_to_top.vue?vue&type=script&lang=js&"
import style0 from "./back_to_top.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports